export const assignKeysToItems = (items: any) => {
	if (Array.isArray(items)) {
		return items.map((x, i) => ({ ...x, key: i }));
	}
	return [];
};
